import { Fancybox } from "@fancyapps/ui";

const galleryImages = document.querySelectorAll('[data-fancybox="gallery"]');
galleryImages.forEach((galleryImage) => {
	const image = galleryImage.firstElementChild as HTMLImageElement;
	galleryImage.setAttribute('data-src', image.src);
});

Fancybox.bind('[data-fancybox="gallery"]', {
	
}); 
